import React, { useEffect, useState } from "react";
import {
  Modal,
  Typography,
  TextareaAutosize,
  Divider,
  Button,
} from "@mui/material";
import Grid from "@mui/system/Grid";

import { flexAllCentre, flexAllEnd } from "../../../styles/mui/styles/display";
import { ModalContainer } from "../style/style";
import {
  ButtonCloseStyle,
  HorizontalDivider,
  ModalGrid,
  TextAreaStyle,
} from "../../../app/styles/styles";
import colors from "../../../styles/colors/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import { PortalUpdateData } from "../../../models/User";
import { getValue } from "../../../utils";
import { maxLength } from "../../../constants/Admin";
import { MyAccountModel } from "../../../models/MyAccount";

export interface PropsFromState {
  loggedInUser: MyAccountModel;
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void;
  portalUpdateState: PortalUpdateData;
}

export interface PropsFromDispatch {
  postAddPortalUpdate: (payload: PortalUpdateData) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const AddPortalUpdate: React.FC<AllProps> = ({
  isOpenModal,
  loggedInUser,
  setIsOpenModal,
  postAddPortalUpdate,
  portalUpdateState,
}) => {
  const [updateText, setUpdateText] = useState<string>("");

  const handleSubmit = () => {
    const payload: PortalUpdateData = {
      userId: getValue(loggedInUser, "providerPortalUser.userId"),
      updateText,
      userCreated: getValue(loggedInUser, "providerPortalUser.email"),
      dateCreated: new Date().toISOString(),
    };
    postAddPortalUpdate(payload);
    setIsOpenModal(false);
  };

  const handleClose = () => {
    setUpdateText("");
    setIsOpenModal(false);
  };

  useEffect(() => {
    if (portalUpdateState) {
      setUpdateText(portalUpdateState?.updateText || "");
    }
  }, [portalUpdateState]);

  return (
    <Modal
      open={isOpenModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={flexAllCentre}
    >
      <Grid container sx={ModalContainer}>
        <Grid size={{ xs: 12 }} mb={1}>
          <Typography
            id="modal-modal-title"
            variant="h1"
            fontWeight={fontWeight[4]}
          >
            Add Portal Update
          </Typography>
          <Divider sx={HorizontalDivider} />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography
            variant="subtitle1"
            color={colors.fonts[6]}
            fontWeight={fontWeight[3]}
          >
            Update:
          </Typography>
        </Grid>
        <Grid size={{ xs: 12 }} sx={ModalGrid}>
          <TextareaAutosize
            minRows={7}
            style={TextAreaStyle}
            maxLength={maxLength}
            value={updateText}
            onChange={(e) => setUpdateText(e.target.value)}
          />
        </Grid>
        <Grid size={{ xs: 12 }} sx={flexAllEnd}>
          <Button
            variant="contained"
            id="btnSubmitAddPortalUpdate"
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Button
            id="btnCloseAddPortalUpdate"
            onClick={handleClose}
            sx={ButtonCloseStyle}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default AddPortalUpdate;
